<app-page-container>
  <div *ngIf="registerComplete != true" class="login-container-content prime-fg-color-3">
    <div class="registerHeader">
      <span
        ><b>{{ 'registration' | translate }}</b></span
      >
    </div>
    <dx-form class="registerForm" #registerForm [minColWidth]="320" [formData]="registerFormData">
      <dxi-item dataField="email" [label]="{ text: 'email' | translate }" [editorOptions]="{ maxLength: 50 }">
        <dxi-validation-rule type="required"></dxi-validation-rule>
        <dxi-validation-rule type="email" message="{{ 'wrongMail' | translate }}"></dxi-validation-rule>
        <dxi-validation-rule type="pattern" [pattern]="configService.emailPattern" message="{{ 'wrongMail' | translate }}"></dxi-validation-rule>
      </dxi-item>

      <dxi-item itemType="group" colCount="2">
        <dxi-item
          dataField="anredeID"
          editorType="dxSelectBox"
          [label]="{ text: 'salutation' | translate }"
          [editorOptions]="{
            dataSource: configService.getKatalog('AnredeKatalog'),
            valueExpr: 'id',
            displayExpr: 'bezeichnung',
            searchMode: 'startswith',
            searchTimeout: 200,
            searchExpr: 'bezeichnung'
          }"
        >
          <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-item>
        <dxi-item
          dataField="titelID"
          editorType="dxSelectBox"
          [label]="{ text: 'title' | translate }"
          [editorOptions]="{
            dataSource: configService.getKatalog('TitelKatalog'),
            valueExpr: 'id',
            displayExpr: 'bezeichnung',
            searchMode: 'startswith',
            searchTimeout: 200,
            searchExpr: 'bezeichnung'
          }"
        >
        </dxi-item>
      </dxi-item>

      <dxi-item dataField="nachname" [label]="{ text: 'lastName' | translate }" [editorOptions]="{ valueChangeEvent: 'keyup', maxLength: 100 }">
        <dxi-validation-rule type="required"></dxi-validation-rule>
      </dxi-item>

      <dxi-item dataField="vorname" [label]="{ text: 'firstName' | translate }" [editorOptions]="{ valueChangeEvent: 'keyup', maxLength: 100 }">
        <dxi-validation-rule type="required"></dxi-validation-rule>
      </dxi-item>

      <dxi-item
        dataField="passwort1"
        [label]="{ text: 'password' | translate }"
        [editorOptions]="{ valueChangeEvent: 'keyup', maxLength: configService.passwordPolicy.maxLaenge, mode: 'password' }"
      >
        <dxi-validation-rule type="required"></dxi-validation-rule>
        <dxi-validation-rule
          type="pattern"
          [pattern]="configService.passwordPolicy.minZiffern"
          [message]="configService.passwordPolicy.minZiffernMessage"
        ></dxi-validation-rule>
        <dxi-validation-rule
          type="pattern"
          [pattern]="configService.passwordPolicy.minKleinBuchstaben"
          [message]="configService.passwordPolicy.minKleinBuchstabenMessage"
        ></dxi-validation-rule>
        <dxi-validation-rule
          type="pattern"
          [pattern]="configService.passwordPolicy.minGrossBuchstaben"
          [message]="configService.passwordPolicy.minGrossBuchstabenMessage"
        ></dxi-validation-rule>
        <dxi-validation-rule
          type="pattern"
          [pattern]="configService.passwordPolicy.minSonderzeichen"
          [message]="configService.passwordPolicy.minSonderzeichenMessage"
        ></dxi-validation-rule>
        <dxi-validation-rule
          type="pattern"
          [pattern]="configService.passwordPolicy.minLaenge"
          [message]="configService.passwordPolicy.minLaengeMessage"
        ></dxi-validation-rule>
      </dxi-item>

      <dxi-item
        dataField="passwort2"
        [label]="{ text: 'repeatPassword' | translate }"
        [editorOptions]="{ valueChangeEvent: 'keyup', maxLength: 50, mode: 'password' }"
      >
        <dxi-validation-rule type="required"></dxi-validation-rule>
      </dxi-item>

      <dxi-item cssClass="psw-richtlinien-container" itemType="group" colCount="3" [template]="'pswRichtlinieTemplate'"> </dxi-item>

      <div *dxTemplate="let data of 'pswRichtlinieTemplate'">
        <dxi-item colSpan="2">
          <span class="psw-richtlinien" [innerHTML]="configService.passwordPolicy.text"></span>
        </dxi-item>
        <dxi-item
          cssClass="benutzername"
          dataField="benutzername"
          colSpan="1"
          [label]="{ text: 'Benutzer' }"
          [editorOptions]="{ valueChangeEvent: 'keyup', maxLength: 50, focusStateEnabled: false }"
        >
        </dxi-item>
      </div>

      <dxi-item cssClass="datenschutz-container" dataField="confirm" [label]="{ visible: false }" [template]="'confirmTemplate'">
        <dxi-validation-rule type="required"></dxi-validation-rule>
      </dxi-item>

      <dxi-item dataField="confirm_2" [visible]="false" [label]="{ visible: false }"> </dxi-item>

      <div *dxTemplate="let data of 'confirmTemplate'">
        <dx-check-box [value]="registerFormData.confirm"> </dx-check-box>
        <span class="datenschutz-link">
          {{ 'privacyAccept_1' | translate }}<a target="_blank" routerLink="/extern/privacy"> {{ 'privacyAccept_2' | translate }}</a
          >{{ 'privacyAccept_3' | translate }} *
        </span>
      </div>
    </dx-form>

    <span class="msg-text color-error">{{ msg }}</span>

    <dx-toolbar class="registerToolbar">
      <dxi-item
        widget="dxButton"
        location="after"
        toolbar="bottom"
        [options]="{
          text: 'register' | translate,
          onClick: onClickRegister,
          type: 'default',
          icon: 'user',
          stylingMode: 'filled',
          disabled: inProcess
        }"
      >
      </dxi-item>

      <dxi-item
        widget="dxButton"
        location="before"
        toolbar="bottom"
        [options]="{ text: 'cancel' | translate, onClick: onClickCancel, type: 'default', icon: 'remove', stylingMode: 'filled' }"
      >
      </dxi-item>
    </dx-toolbar>
  </div>

  <div class="login-container-content-2 prime-fg-color-3" *ngIf="registerComplete">
    <span class="register-text"
      ><b>{{ 'confirmMailAddress' | translate }}</b></span
    >
    <dx-toolbar class="registerToolbar">
      <dxi-item
        widget="dxButton"
        location="center"
        toolbar="bottom"
        [options]="{ text: 'toStartPage' | translate, onClick: onClickToStart, type: 'default', icon: 'home', stylingMode: 'filled' }"
      >
      </dxi-item>
    </dx-toolbar>
  </div>
</app-page-container>
